
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/omnichannel/qr-service",
      function () {
        return require("private-next-pages/india/omnichannel/qr-service.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/omnichannel/qr-service"])
      });
    }
  